import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './Assets/CSS/bootstrap.min.css';
import './Assets/CSS/Style.css';
import './Assets/CSS/animate.min.css';
ReactDOM.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
  document.getElementById('root')
);